import axios from 'axios'
import { useErrorStore } from 'stores/common/error'
import { useAuthStore } from 'stores/receiver/account/auth/auth'
import { i18n } from 'boot/common/i18n'

import type { ErrorRes, ViolationError } from 'types/common/error/error'

export default (error: unknown) => {
  if (axios.isAxiosError(error) && error.response?.status === 409) {
    const data: ErrorRes<ViolationError> = error.response?.data
    // Check if we have an violation on sudo_code
    const sudoError = data.payload.violations?.find(
      (el) => el.property_path === 'sudo_code'
    )
    // Remove the invalid sudo_code
    if (sudoError) {
      useErrorStore().backErrors['sudo_code'] = i18n.global.t(
        'account.security.password.sudoError'
      )
      useAuthStore().sudo_code = null
    }
  }
}
